import { useEffect, useState } from 'react';
import { getPartners } from '../api/digiscore-api';

export function usePartnersList(token) {
  const [partners, setPartners] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState(undefined);

  useEffect(() => {
    let mounted = true;
    (async () => {
      if (!token) return;
      try {
        setLoading(true);
        const data = await getPartners(token);
        if (mounted) setPartners(data || []);
      } catch (e) {
        setError(e);
        console.error('[usePartnersList] error:', e);
      } finally {
        if (mounted) setLoading(false);
      }
    })();
    return () => {
      mounted = false;
    };
  }, [token]);

  return { partners, isLoading, error };
}